import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsEmailOldRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsEmailOldRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { NotFound } from './ui/not-found/index.tsx';
import { navigation } from './common/constants.tsx';
import { HelpCenterSettingsEmail, LazyHelpCenterSettingsEmail } from './ui/email/index.tsx';

// Delete this as part of berry-4386-add-helpcenterid-to-routes FG clean up
export const helpCenterSettingsEmailOldRouteEntry = createEntry(
	helpCenterSettingsEmailOldRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.email',
		layout: serviceProjectLayout,
		navigation,
		component: componentWithFG(
			'berry-4386-add-helpcenterid-to-routes',
			NotFound,
			componentWithFG('jcs_master_flag', HelpCenterSettingsEmail, ErrorPagesNotFound),
		),
		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsEmail],
		resources: [...getServiceDeskSettingsResources()],
	}),
);
